import {
  validatePortugueseMod11,
  validateSwedishLuhn
} from '@ingka-group-digital/edve-validation-utils';
import CONFIG from 'Config/settings';
import { t } from 'Utils/localization/i18next';
import validationMessage from '../validationMessage/validationMessage';
import {
  getPrimitiveRegExp,
  matchesFieldPolicy,
  resolveFieldPolicyRegExps
} from '../validationRules/validationRules';

// Validation rules for government IDs and passports

const skipEmpty = validator => (value = '', ...args) => {
  if (!value) {
    return undefined;
  }

  return validator(value, ...args);
};

const socialSecurityNumber = skipEmpty((value, label, { message } = {}) => {
  const country = CONFIG.COUNTRY.toUpperCase();
  const resolvedPolicy = resolveFieldPolicyRegExps('GOVERNMENT_ID', country);
  if (
    !matchesFieldPolicy(value, resolvedPolicy) ||
    !validateSwedishLuhn(value)
  ) {
    return validationMessage('socialSecurityNumber', label, message);
  }
  return undefined;
});

// NIF: Portuguese tax identification number, called Número de Identificação Fiscal
const nif = skipEmpty(value => {
  const error = [t('forms.validation.nif')];
  const nifRegExp = getPrimitiveRegExp('pt.government_id.nif');
  if (!nifRegExp || !nifRegExp.test(value) || !validatePortugueseMod11(value)) {
    return error;
  }
  return undefined;
});

// DNI: Spanish national identity document number, Documento Nacional de Identidad.
const dni = skipEmpty(value => {
  const error = [t('forms.validation.document')];
  const dniRegExp = getPrimitiveRegExp('es.government_id.dni');
  const nieRegExp = getPrimitiveRegExp('es.government_id.nie');
  if (
    (!dniRegExp || !dniRegExp.test(value)) &&
    (!nieRegExp || !nieRegExp.test(value))
  ) {
    return error;
  }
  return undefined;
});

const passport = skipEmpty(value => {
  const error = [t('forms.validation.passport')];
  const passportRegExp = getPrimitiveRegExp('es.government_id.passport_number');
  if (!passportRegExp || !passportRegExp.test(value)) {
    return error;
  }
  return undefined;
});

export { socialSecurityNumber, nif, dni, passport };
